function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "x1");

function SvgIcnTimes1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(7.24 28.73)",
    style: {
      fill: "#5e5e5d",
      fontSize: 24,
      fontFamily: "Inter",
      fontWeight: 700
    }
  }, _ref), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTimes1);
export default __webpack_public_path__ + "static/media/icn-times1.21b3b66098bd2be373d80f31d8b02e32.svg";
export { ForwardRef as ReactComponent };